
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meddelanden/[chatId]",
      function () {
        return require("private-next-pages/meddelanden/[chatId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/meddelanden/[chatId]"])
      });
    }
  